import axios from 'axios';

export const poloApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/polo`,
    headers: {
        'Content-Type': 'application/json'
    }
})